import React from 'react';

const MissingDay = () => {
    return (
        <p>It appears that we can't find the day you are looking for.</p>
    )
}

export default MissingDay;